import { SharedState } from '@trello/shared-state';

export enum WebSocketState {
  DISCONNECTED = 'disconnected',
  CONNECTING = 'connecting',
  CONNECTED = 'connected',
  RECONNECTING = 'reconnecting',
  WAITING_FOR_FOCUS = 'waiting_for_focus',
  WAITING_FOR_USER = 'waiting_for_user',
  WAITING_TO_RECONNECT = 'waiting_to_reconnect',
  CLOSED = 'closed',
  FORCE_DISCONNECTED = 'force_disconnected',
  DESTROYED = 'destroyed',
}

/**
 * Shared state that broadcasts the current ws state
 */
export const webSocketState = new SharedState<WebSocketState>(
  WebSocketState.DISCONNECTED,
);
